module.exports = __webpack_public_path__ + "img/Skyservice_logo_2022_512.d3c0af50.png";